module.exports = __webpack_public_path__ + "static/media/message.265cd5aa.png";